const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const CreateRelevantWorkflowPage = () => import(/* webpackChunkName: "relevant" */'@/components/common/CreateRelevantWorkflowPage');
const KnowledgeSearch = () => import(/* webpackChunkName: "knowledgeManage" */'@/components/pages/knowledgeManage/KnowledgeSearch');

export default [
  {
    path: '/relevant',
    name: 'relevant',
    meta: {
      roles: ['WF_RELEVANT_QUERY']
    },
    component: Layout,
    children: [
      {
        path: '/event-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createEventRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_event',
          activeMenu: '/event-manage/event-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '关联单据',
              path: '/event-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/project-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createProjectRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_pm',
          activeMenu: '/project-manage/project-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '项目管理',
              path: '/project-manage/project-bench'
            },
            {
              name: '关联单据',
              path: '/project-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/knowledge-manage/search-knowledge-workflow',
        name: 'searchKnowledgeWorkflow',
        meta: {
          title: '知识检索',
          hidden: true,
          activeMenu: '/knowledge-manage/knowledge-bench',
          roles: ['WF_RELEVANT_ADD'],
          componentName: 'KnowledgeSearch',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            },
            {
              name: '新建知识单据',
              path: '/knowledge-manage/search-knowledge-workflow'
            }
          ]
        },
        component: KnowledgeSearch
      },
      {
        path: '/knowledge-manage/:id/create-relevant-workflow',
        name: 'createKnowledgeRelevantWorkflow',
        props: true,
        meta: {
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_knowledge',
          activeMenu: '/knowledge-manage/knowledge-bench',
          roles: ['WF_RELEVANT_QUERY'],
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '知识管理',
              path: '/knowledge-manage/knowledge-bench'
            },
            {
              name: '关联单据',
              path: '/knowledge-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/task-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createTaskRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_task',
          activeMenu: '/task-manage/task-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '任务管理',
              path: '/task-manage/task-bench'
            },
            {
              name: '关联单据',
              path: '/event-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/release-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createReleaseRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_release',
          activeMenu: '/release-manage/task-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '发布管理',
              path: '/release-manage/release-bench'
            },
            {
              name: '关联单据',
              path: '/release-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/change-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createChangeRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_change',
          activeMenu: '/change-manage/change-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '变更管理',
              path: '/change-manage/change-bench'
            },
            {
              name: '关联单据',
              path: '/change-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      },
      {
        path: '/problem-manage/:id/create-relevant-workflow',
        props: true,
        name: 'createProblemRelevantWorkflow',
        meta: {
          roles: ['WF_RELEVANT_QUERY'],
          title: '关联单据',
          hidden: true,
          docType: 'doc_type_problem',
          activeMenu: '/problem-manage/problem-bench',
          componentName: 'CreateRelevantWorkflowPage',
          breadcrumb: [
            {
              name: '问题管理',
              path: '/problem-manage/problem-bench'
            },
            {
              name: '关联单据',
              path: '/problem-manage/:id/create-relevant-workflow'
            }
          ]
        },
        component: CreateRelevantWorkflowPage
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/relevant.js